export default __webpack_public_path__ + "assets/png/28bfaa5e76d249dd8de1442e3a89e707.png";